<div class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/3 md:p-6">
  <h3 class="text-base font-semibold text-gray-800 dark:text-white/90">Translation Status</h3>
  <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">Last file import per translation type</p>

  @if (loading()) {
    <div class="flex h-32 items-center justify-center">
      <svg class="h-6 w-6 animate-spin text-blue-500" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
    </div>
  } @else if (error()) {
    <p class="mt-4 rounded-lg border border-red-200 bg-red-100 p-3 text-sm text-red-600">{{ error() }}</p>
  } @else {
    <div class="mt-4 overflow-x-auto">
      <table class="w-full text-left text-sm text-gray-700 dark:text-gray-300">
        <thead class="text-xs uppercase text-gray-400 dark:text-gray-500">
          <tr class="border-b border-gray-100 dark:border-gray-800">
            <th class="py-2 pr-4 font-medium">Type</th>
            <th class="py-2 pr-4 font-medium">Last Imported</th>
            <th class="py-2 pr-4 font-medium">Total</th>
            <th class="py-2 pr-4 font-medium">New</th>
            <th class="py-2 pr-4 font-medium">Updated</th>
            <th class="py-2 font-medium">Skipped</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.importType) {
            <tr class="border-b border-gray-50 last:border-0 dark:border-gray-800/60">
              <td class="py-2.5 pr-4 font-medium text-gray-800 dark:text-white/90">{{ row.label }}</td>
              @if (row.latest; as item) {
                <td class="py-2.5 pr-4 text-xs">{{ item.createdDate | date:'yyyy-MM-dd HH:mm' }}</td>
                <td class="py-2.5 pr-4">{{ item.totalItems }}</td>
                <td class="py-2.5 pr-4 text-green-600">{{ item.newTranslation }}</td>
                <td class="py-2.5 pr-4 text-blue-600">{{ item.updateTranslations }}</td>
                <td class="py-2.5">{{ item.skipRows }}</td>
              } @else {
                <td class="py-2.5 pr-4 text-gray-400" colspan="5">No imports yet</td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
